import React, { FC } from 'react';
import {
  createStyles,
  Theme,
  makeStyles,
  createMuiTheme,
} from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { Typography, Box } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  item: {
    color: 'black',
    display: 'inline',
  },
  inline: {
    display: 'inline',
  },
}));

export type TitleModel = {
  type: 'title';
  title: string;
};

interface ProductItemProps {
  model: TitleModel;
}

const TitleTableItem: FC<ProductItemProps> = (props) => {
  const theme = createMuiTheme();
  const classes = useStyles(theme);
  return (
    <ListItem>
      <ListItemText
        disableTypography
        primary={(
          <Box>
            <Typography className={classes.item}>
              {props?.model.title}
            </Typography>
          </Box>
        )}
      />
    </ListItem>
  );
};

export default TitleTableItem;
